enum Duration {
    mensual = "Mensual",
    quinc = "Quincenal"

}
export function getPeriodDuration(duration: number): Duration {
  return duration === 0 ? Duration.mensual : Duration.quinc;
}
